import React from 'react'
import { ThemeProvider } from 'styled-components';
import { Provider } from "react-redux";
import { isEqual } from 'lodash'


import theme from '../../theme';
import Scenes from '../../scenes'
import store from "../../store";

import Modal from './modal'
import { actions as configActions } from "~/config";
import { init as initI18n } from "~/i18n";

export default class GratifyProvider extends React.Component {
  state = {
    initialized: false
  }
  async componentDidMount() {
    await this.init(this.props);
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const { appId, configuration } = this.props

    if(appId !== prevProps.appId || !isEqual(configuration, prevProps.configuration)) {
      await this.init(this.props);
    }
  }

  async init(props) {
    const { appId, configuration = {}} = props

    if(configuration.language) {
      initI18n({lng: configuration.language});
    }else {
      initI18n();
    }
    if(!appId) {
      store.dispatch(configActions.setConfig({ ...configuration }));
      return;
    }else {
      store.dispatch(configActions.setConfig({ ...configuration, appId }));
    }

    if(!this.state.initialized) {
      this.setState({initialized: true})
    }
  }

  render() {
    return (
      <Provider store={store}>
        { this.state.initialized ? <Modal>
          <ThemeProvider theme={ theme }>
            <Scenes />
          </ThemeProvider>
        </Modal> : null }
        {this.props.children}
      </Provider>
    )
  }
}
